export const TestIds = {
  SIDE_NAVIGATION: {
    TOGGLE: 'side-navigation-toggle',
    NEW_CLASS: 'new-class',
    BUG_REPORT: 'bug-report',
    SETTINGS: 'settings',
    CLASSROOM: {
      SELF: 'classroom',
      HOME: 'classroom-home',
      LEARNING_PLAN: 'classroom-learning-plan',
      PERFORMANCE: 'classroom-performance',
      SETTINGS: 'classroom-settings'
    },
    LANGUAGES: {
      ENGLISH: 'languages-english',
      GERMAN: 'languages-german',
      FRENCH: 'languages-french',
      SPANISH: 'languages-spanish'
    }
  },
  CLASSROOM: {
    HEADER: {
      NAME: 'classroom-header-name',
      QR_LOGIN: 'classroom-header-qr-login'
    },
    NEW_CLASS: {
      USING_TEXTBOOK: 'new-class-using-textbook',
      WITHOUT_TEXTBOOK: 'new-class-without-textbook'
    },
    QR_POPUP: {
      QR_CODE: 'classroom-qr-popup-qr-code',
      PIN_CODE: 'classroom-qr-popup-pin-code'
    },
    SETTINGS: {
      DELETE_CLASS_BUTTON: 'classroom-settings-delete-class-button',
      ADD_STUDENTS_BUTTON: 'classroom-settings-add-students-button',
      STUDENT_CARD: 'classroom-settings-student-card',
      DELETE_STUDENT_ICON: 'classroom-settings-student-card-delete-icon'
    }
  },
  LIBRARY: {
    TABS: {
      DISCOVER: 'libary-tabs-discovery',
      PACKAGES: 'libary-tabs-packages',
      ACTIVITIES: 'libary-tabs-activities',
      BOOKS: 'libary-tabs-books',
      MY_CONTENT: 'libary-tabs-my-content'
    }
  },
  SETTINGS: {
    USER_PROFILE: {
      SAVE: 'settings-user-profile-save',
      FIRST_NAME: 'settings-user-profile-first-name',
      LAST_NAME: 'settings-user-profile-last-name',
      EMAIL: 'settings-user-profile-email',
      CHANGE_PASSWORD: 'settings-user-profile-change-password',
      RESET_TUTORIAL: 'settings-user-profile-reset-tutorial'
    },
    LOGOUT: 'logout'
  },
  LEARNING_PLAN: {
    HOME: {
      LEARNING_PLAN_SECTION: 'learning-plan-section',
      LEARNING_PLAN_ADD_NEW: 'learning-plan-add-new',
      UNIT_ITEM: 'learning-plan-unit-item',
      IMPORT: 'learning-plan-home-import',
      LESSON_CARD: 'learning-plan-lesson-card',
      NEW_PAGE: 'learning-plan-new-page',
      COMBINE_LESSONS_SWITCH: 'learning-plan-combine-lessons-switch',
      NEW_UNIT: 'learning-plan-new-unit',
      OPEN_UNIT_MENU: 'learning-plan-open-unit-menu',
      RENAME_UNIT: 'learning-plan-rename-unit',
      DELETE_UNIT: 'learning-plan-delete-unit',
      COMPLETE_UNIT: 'learning-plan-complete-unit'
    },
    DELETE_POPUP: {
      INPUT_FIELD: 'learning-plan-delete-popup-input-field',
      DELETE_BUTTON: 'learning-plan-delete-popup-delete-button',
      CANCEL_BUTTON: 'learning-plan-delete-popup-cancel-button'
    },
    LESSON_CARD: {
      COMPLETE_CHECKBOX: 'lesson-card-complete-checkbox',
      DELETE_OPTION: 'lesson-card-delete',
      RENAME_OPTION: 'lesson-card-rename',
      DUPLICATE_OPTION: 'lesson-card-duplicate',
      POPUP_CONFIRM_DELETE: 'lesson-card-popup-confirm-delete',
      POPUP_CANCEL: 'lesson-card-popup-cancel'
    },
    LESSON_PAGE: {
      INDIVIDUAL_TABS: {
        CLASSROOM: 'page-individual-tabs-classroom',
        HOMEWORK: 'page-individual-tabs-homework',
        TEST: 'page-individual-tabs-test'
      },
      GAME_TABS: {
        CLASSROOM: 'page-game-tabs-classroom',
        HOMEWORK: 'page-game-tabs-homework',
        INDIVIDUAL: 'page-game-tabs-individual'
      },
      ACTIVITY_CARDS: {
        HUNTWORDS: 'activity_card.huntwords',
        PEXESO: 'activity_card.pexeso',
        WHEEL: 'activity_card.wheel',
        FLIPCARDS: 'activity_card.flipcards',
        PREPOSITIONS: 'activity_card.prepositions',
        MILLIONAIRE: 'activity_card.millionaire',
        PICSMATCH: 'activity_card.picsmatch',
        QUIZ: 'activity_card.quiz',
        WORD_AHOY: 'activity_card.word_ahoy',
        WILD_WEST: 'activity_card.wild_west',
        WORD_LADDERS: 'activity_card.word_ladders',
        FLASHCARDS: 'activity_card.flashcards',
        SPELL_WIZARD: 'activity_card.spell_wizard',
        WORKSHEETS_MATCH_ELEMENTS: 'activity_card.worksheets_match_elements',
        WORKSHEETS_ONE_TO_MANY: 'activity_card.worksheets_one_to_many',
        WORKSHEETS_PUZZLE: 'activity_card.worksheets_puzzle'
      },
      TEMPLATE_CARDS: {
        BLANK: 'template_card.blank',
        GENERAL: 'template_card.general',
        INTRODUCTION: 'template_card.introduction',
        TESTING: 'template_card.testing',
        REVIEW: 'template_card.review',
        SPEAKING: 'template_card.speaking'
      },
      ACTIVITY: {
        ACTIVITY_CARD: 'activity-card',
        PLAY_BUTTON: 'activity-play-button',
        OTHER_ACTIONS_BUTTON: 'activity-other-actions-button'
      },
      ACTIVITY_DETAIL: {
        ADD_TO_WORKSPACE: 'activity-detail-add-to-workspace'
      },
      CONTENT_LIBRARY: {
        DISCOVERY_TAB: 'content-library-discovery-tab',
        MY_CONTENT_TAB: 'content-library-my-content-tab',
        PACKAGES_TAB: 'content-library-packages-tab',
        GRAMMAR_TAB: 'content-library-grammar-tab',
        BOOKS_TAB: 'content-library-books-tab',
        SEARCH_FIELD: 'content-library-search-field',
        SEARCH_RESULT: 'content-library-search-result',
        ADD_MORE_PACKAGES_BUTTON: 'content-library-add-more-packages-button',
        CONTENT_SECTION: 'content-library-content-section'
      },
      EDIT_CONTENT: 'page-edit-lesson-content-button',
      UNSAVED_CHANGES_ICON: 'lesson-unsaved-changes-icon'
    }
  },
  GAMES: {
    ROOT_DIALOG: {
      BACK: 'games-root-dialog-back'
    },
    START_GAME: 'games-start-game-button'
  },
  COMMON_ELEMENTS: {
    X_CLOSE_BUTTON: 'x-close-button'
  }
}
